export default __webpack_public_path__ + "static/media/help.341f80f8.png";